import { AdminFormRow } from '@ui';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { CreateOpoContactFormValues } from './config';

export const CreateOpoContactEmailField = () => {
  const { control } = useFormContext<CreateOpoContactFormValues>();

  return (
    <AdminFormRow title="Email" isRequired inputWrapperClass="max-w-[20rem]">
      <Controller
        name="email"
        control={control}
        render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
          <Input
            {...field}
            aria-label="Contact Email"
            type="email"
            value={value || ''}
            isInvalid={invalid}
            errorMessage={error?.message}
          />
        )}
      />
    </AdminFormRow>
  );
};
